import * as AccountStore from '@store/account/account'

type RightList =
  // USELESS RIGHTS
  | 'CAN_CONNECT_ON_CKCC'
  | 'CAN_SEE_INPROGRESS_BUSINESS'
  | 'CAN_CREATE_DECLARATION'
  | 'CAN_CREATE_ORPHAN'
  | 'CAN_EDIT_DECLARATION_BEFORE_SENDING'
  // ACCESS RIGHTS
  | 'CAN_SEE_ORPHAN'
  | 'CAN_SEE_ALL_BUSINESSES'
  | 'CAN_SEE_REGION_BUSINESSES'
  | 'CAN_SEE_COMPANY_BUSINESSES'
  | 'CAN_SEE_ENDED_BUSINESS'
  | 'CAN_FILTER_ON_RESPONSIBLE'
  | 'CAN_FILTER_ON_COMPANY'
  | 'CAN_FILTER_ON_COMPANYGROUP'
  | 'CAN_FILTER_ON_SOURCE'
  | 'CAN_FILTER_ON_REGION'
  // EDITION RIGHTS
  | 'CAN_EDIT_DECLARATION_TEXTS'
  | 'CAN_AFFECT_ORPHAN'
  | 'CAN_RELEASE_BREAKPOINT'
  | 'CAN_REASSIGN_DECLARATIONS'
  // ADMINISTRATION RIGHTS
  | 'CAN_ADMIN_COMPANY'
  | 'CAN_ADMIN_EXT_USERS'
  | 'CAN_ADMIN_INT_USERS'
  | 'CAN_AFFECT_COMPANY_ON_BUSINESS'
  | 'CAN_FILTER_WITH_WITHOUT'
  | 'CAN_SEE_DATA'
  | 'CAN_CREATE_USERS'

const SUPER_ADMIN_RIGHTS: RightList[] = [
  'CAN_CONNECT_ON_CKCC',
  'CAN_SEE_ORPHAN',
  'CAN_SEE_INPROGRESS_BUSINESS',
  'CAN_CREATE_DECLARATION',
  'CAN_CREATE_ORPHAN',
  'CAN_EDIT_DECLARATION_BEFORE_SENDING',
  'CAN_SEE_ALL_BUSINESSES',
  'CAN_SEE_REGION_BUSINESSES',
  'CAN_SEE_ENDED_BUSINESS',
  'CAN_EDIT_DECLARATION_TEXTS',
  'CAN_AFFECT_ORPHAN',
  'CAN_RELEASE_BREAKPOINT',
  'CAN_ADMIN_COMPANY',
  'CAN_FILTER_ON_COMPANYGROUP',
  'CAN_ADMIN_EXT_USERS',
  'CAN_ADMIN_INT_USERS',
  'CAN_AFFECT_COMPANY_ON_BUSINESS',
  'CAN_FILTER_ON_RESPONSIBLE',
  'CAN_FILTER_ON_COMPANY',
  'CAN_FILTER_ON_SOURCE',
  'CAN_FILTER_ON_REGION',
  'CAN_FILTER_WITH_WITHOUT',
  'CAN_SEE_DATA',
  'CAN_CREATE_USERS',
  'CAN_REASSIGN_DECLARATIONS',
]

const INTERN_USER_RIGHTS: RightList[] = [
  'CAN_CONNECT_ON_CKCC',
  'CAN_SEE_ORPHAN',
  'CAN_SEE_INPROGRESS_BUSINESS',
  'CAN_CREATE_DECLARATION',
  'CAN_CREATE_ORPHAN',
  'CAN_EDIT_DECLARATION_BEFORE_SENDING',
  'CAN_SEE_ALL_BUSINESSES',
  'CAN_SEE_REGION_BUSINESSES',
  'CAN_SEE_ENDED_BUSINESS',
  'CAN_EDIT_DECLARATION_TEXTS',
  'CAN_AFFECT_ORPHAN',
  'CAN_RELEASE_BREAKPOINT',
  'CAN_ADMIN_INT_USERS',
  'CAN_FILTER_ON_RESPONSIBLE',
  'CAN_FILTER_ON_COMPANY',
  'CAN_FILTER_ON_SOURCE',
  'CAN_FILTER_ON_REGION',
  'CAN_FILTER_WITH_WITHOUT',
  'CAN_FILTER_ON_COMPANYGROUP',
]

const INTERN_ADMIN_RIGHTS: RightList[] = [
  'CAN_CONNECT_ON_CKCC',
  'CAN_SEE_ORPHAN',
  'CAN_SEE_INPROGRESS_BUSINESS',
  'CAN_CREATE_DECLARATION',
  'CAN_CREATE_ORPHAN',
  'CAN_EDIT_DECLARATION_BEFORE_SENDING',
  'CAN_SEE_REGION_BUSINESSES',
  'CAN_SEE_ENDED_BUSINESS',
  'CAN_EDIT_DECLARATION_TEXTS',
  'CAN_AFFECT_ORPHAN',
  'CAN_RELEASE_BREAKPOINT',
  'CAN_ADMIN_COMPANY',
  'CAN_ADMIN_EXT_USERS',
  'CAN_ADMIN_INT_USERS',
  'CAN_AFFECT_COMPANY_ON_BUSINESS',
  'CAN_FILTER_ON_RESPONSIBLE',
  'CAN_FILTER_ON_COMPANY',
  'CAN_FILTER_ON_SOURCE',
  'CAN_FILTER_ON_REGION',
  'CAN_FILTER_WITH_WITHOUT',
  'CAN_FILTER_ON_COMPANYGROUP',
  'CAN_SEE_DATA',
  'CAN_REASSIGN_DECLARATIONS',
]

const EXTERN_USER_RIGHTS: RightList[] = [
  'CAN_CONNECT_ON_CKCC',
  'CAN_SEE_COMPANY_BUSINESSES',
  'CAN_SEE_ORPHAN',
  'CAN_SEE_INPROGRESS_BUSINESS',
  'CAN_CREATE_DECLARATION',
  'CAN_CREATE_ORPHAN',
  'CAN_EDIT_DECLARATION_BEFORE_SENDING',
  'CAN_FILTER_WITH_WITHOUT',
  'CAN_FILTER_ON_SOURCE',
]

const EXTERN_ADMIN_RIGHTS: RightList[] = [
  'CAN_CONNECT_ON_CKCC',
  'CAN_SEE_COMPANY_BUSINESSES',
  'CAN_SEE_ORPHAN',
  'CAN_SEE_INPROGRESS_BUSINESS',
  'CAN_CREATE_DECLARATION',
  'CAN_CREATE_ORPHAN',
  'CAN_EDIT_DECLARATION_BEFORE_SENDING',
  'CAN_FILTER_WITH_WITHOUT',
  'CAN_FILTER_ON_SOURCE',
  'CAN_ADMIN_EXT_USERS',
]

const connected_user_rights = (): RightList[] => {
  const connecter_user = AccountStore.store.getState().account
  return connecter_user
    ? connecter_user.role === 'super_admin'
      ? SUPER_ADMIN_RIGHTS
      : connecter_user.role === 'intern_admin'
      ? INTERN_ADMIN_RIGHTS
      : connecter_user.role === 'intern_user'
      ? INTERN_USER_RIGHTS
      : connecter_user.role === 'extern_admin'
      ? EXTERN_ADMIN_RIGHTS
      : EXTERN_USER_RIGHTS
    : []
}

const canSeeAllBusinesses = () => true // SERVER
const canSeeRegionBusinesses = () => true // SERVER
const canSeeCompanyBusinesses = () => true // SERVER

const canSeeEndedBusinesses = () => connected_user_rights().includes('CAN_SEE_ENDED_BUSINESS')
const canEditDeclarationTexts = () => connected_user_rights().includes('CAN_EDIT_DECLARATION_TEXTS')
const canAffectOrphan = () => connected_user_rights().includes('CAN_AFFECT_ORPHAN')
const canReleaseBreakpoint = () => connected_user_rights().includes('CAN_RELEASE_BREAKPOINT')
const canAdminCompany = () => connected_user_rights().includes('CAN_ADMIN_COMPANY')
const canAdminExtUsers = () => connected_user_rights().includes('CAN_ADMIN_EXT_USERS')
const canAdminIntUsers = () => connected_user_rights().includes('CAN_ADMIN_INT_USERS')
const canAffectCompanyOnBusiness = () => connected_user_rights().includes('CAN_AFFECT_COMPANY_ON_BUSINESS')
const canSeeOrphans = () => connected_user_rights().includes('CAN_SEE_ORPHAN')
const canFilterOnResponsible = () => connected_user_rights().includes('CAN_FILTER_ON_RESPONSIBLE')
const canFilterOnCompany = () => connected_user_rights().includes('CAN_FILTER_ON_COMPANY')
const canFilterOnCompanyGroup = () => connected_user_rights().includes('CAN_FILTER_ON_COMPANYGROUP')
const canFilterOnSource = () => connected_user_rights().includes('CAN_FILTER_ON_SOURCE')
const canFilterOnRegion = () => connected_user_rights().includes('CAN_FILTER_ON_REGION')
const canFilterWithWithout = () => connected_user_rights().includes('CAN_FILTER_WITH_WITHOUT')
const canSeeData = () => connected_user_rights().includes('CAN_SEE_DATA')
const canCreateUsers = () => connected_user_rights().includes('CAN_CREATE_USERS')
const canReassignDeclarations = () => connected_user_rights().includes('CAN_REASSIGN_DECLARATIONS')

const rights = {
  canSeeAllBusinesses,
  canSeeRegionBusinesses,
  canSeeCompanyBusinesses,
  canSeeEndedBusinesses,
  canEditDeclarationTexts,
  canAffectOrphan,
  canReleaseBreakpoint,
  canAdminCompany,
  canAdminExtUsers,
  canAdminIntUsers,
  canAffectCompanyOnBusiness,
  canSeeOrphans,
  canFilterOnResponsible,
  canFilterOnCompany,
  canFilterOnSource,
  canFilterOnRegion,
  canFilterWithWithout,
  canFilterOnCompanyGroup,
  canSeeData,
  canCreateUsers,
  canReassignDeclarations,
}

export default rights
